import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import moment from "moment";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { CheckDto } from "src/app/shared/models/check-dto";
import { CustomerDto } from "src/app/shared/models/DTO/customer-dto";
import { MyFocusLoyaltyMemberDTO } from "src/app/shared/models/DTO/MyFocus-Loyalty.dto";

@Component({
	selector: "app-customer-detail",
	templateUrl: "./customer-detail.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class CustomerDetailComponent implements OnInit, OnDestroy {
	@Input() customer: CustomerDto;
	@Input() customerKey: string;
	@Input() venueKey: number;
	@Output() closeEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

	checkLoadComplete: boolean = false;
	checkSelected: CheckDto;
	checks: CheckDto[];
	customerSubscription: Subscription = new Subscription();

	loyaltyDto: MyFocusLoyaltyMemberDTO;

	moment: any = moment;

	viewMode: number = 0;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		public customerService: CustomerService,
		public userService: UserService,
		private route: ActivatedRoute,
		private router: Router
	) {}
	ngOnDestroy(): void {
		this.customerService.customer.next(undefined);
		this.customerSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.app.loading(true);
		// this.init(this.customerKey || this.customer.key);

		this.customerKey = this.customerKey || this.route.snapshot.paramMap.get("customerKey");
		console.log("customerKey", this.customerKey);
		this.customerSubscription.add(
			this.customerService.customer.subscribe((data) => {
				this.app.loading(false);
				this.customer = data;
			})
		);
		this.customerService.setCustomer(this.customerKey || this.customer.key);
	}

	onClose() {
		this.closeEmitter.emit(true);
		this.router.navigate(["/cc/customers"]);
	}

	async save() {
		await this.focuslink.customerPatch(
			this.venueKey,
			this.customerService.customer.value.key,
			this.customerService.customer.value.toCustomerVenue(this.venueKey)
		);
	}
}
